import type { Client } from '../../../api/client.js';

/**
 * Compensations entre héritiers (PARITE-5, RG-28), en LECTURE : `compensations.dossier`, plus la question BETA du contexte
 * `D08.compensations` (routes BETA existantes). Aucune écriture de compensation.
 */
export interface Compensations {
  dossierId: string;
  warning: string;
  options: { code: string; label: string; description: string; recommended: boolean }[];
  debts: {
    creditorPersonId: string;
    creditorDisplayName: string;
    debtorPersonId: string;
    debtorDisplayName: string;
    amount: { amountCents: number; currency: 'EUR' };
  }[];
  calculation: { status: 'a_valider'; note: string; mention: string };
  unavailableReason: string | null;
  dataVersion: string;
}

export interface QuestionBetaCompensation {
  id: string;
  key: string;
  question: string;
  options: { code: string; label: string }[];
}

export interface SourceCompensations {
  lire(): Promise<Compensations>;
  questions(): Promise<QuestionBetaCompensation[]>;
  repondre(cle: string, option: string): Promise<void>;
}

export const CONTEXTE_BETA_COMPENSATIONS = 'D08.compensations';
export const PERMISSION_LIRE_COMPENSATIONS = 'compensation:read:dossier';

export function creerSourceCompensations(client: Client, dossierId: string): SourceCompensations {
  return {
    lire: () => client.appeler<Compensations>('compensations.dossier', { parametres: { dossierId } }),
    questions: () =>
      client.appeler<QuestionBetaCompensation[]>('beta.questionsDues', { requete: { contexte: CONTEXTE_BETA_COMPENSATIONS } }),
    repondre: async (cle, option) => {
      await client.appeler('beta.repondre', { parametres: { cle }, corps: { option, context: { ecran: CONTEXTE_BETA_COMPENSATIONS } } });
    },
  };
}
